module.exports = __webpack_public_path__ + "img/phone@1x.ebecd547.svg";